import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import router from './router/index'
import './assets/main.css'

import { createHead } from '@unhead/vue/client'

const app = createApp(App)
const pinia = createPinia()
const head = createHead()

app.use(pinia)
app.use(vuetify)
app.use(router)
app.use(head)

// Intercept all Vue errors to prevent browser extensions from crashing linearly
app.config.errorHandler = (err, instance, info) => {
    console.error('[Vue Error Trapped Safely]:', err);
    console.error('Error info:', info);
};
app.config.warnHandler = (msg, instance, trace) => {
    console.log('[Vue Warn Trapped Safely]:', msg, trace);
};

app.mount('#app')
